var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_27783",
    "data-name": "Group 27783",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13942",
    "data-name": "Rectangle 13942",
    width: 22,
    height: 22,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25628",
    "data-name": "Group 25628",
    transform: "translate(1.493 5.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25626",
    "data-name": "Group 25626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16545",
    "data-name": "Path 16545",
    d: "M20.913,11.973S17.384,6,11.207,6,1.5,11.973,1.5,11.973s3.53,5.973,9.707,5.973S20.913,11.973,20.913,11.973Z",
    transform: "translate(-1.5 -6)",
    fill: "none",
    stroke: "#00aff1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16546",
    "data-name": "Path 16546",
    d: "M13.5,15.524A2.024,2.024,0,1,0,15.524,13.5,2.024,2.024,0,0,0,13.5,15.524Z",
    transform: "translate(-5.817 -9.555)",
    fill: "none",
    stroke: "#00aff1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.a3473dab785f93e2a49cdcb3cae01d86.svg";
export { ForwardRef as ReactComponent };